import { render, staticRenderFns } from "./AdminDatePicker.vue?vue&type=template&id=565f0dfb&scoped=true"
import script from "./AdminDatePicker.vue?vue&type=script&lang=js"
export * from "./AdminDatePicker.vue?vue&type=script&lang=js"
import style0 from "./AdminDatePicker.vue?vue&type=style&index=0&id=565f0dfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565f0dfb",
  null
  
)

export default component.exports